// src/pages/ResetPassword.js
import React, { useState,useEffect } from "react";
import { resetPassword, forgotPassword } from "../api/auth/auth";
import PasswordField from "../components/common/PasswordField";
import { useNavigate } from 'react-router-dom';

import { 
  validateName, 
  validateEmail, 
  validatePassword, 
  validateConfirmPassword, 
  validatePhoneNumber,
  calculatePasswordStrength 
} from "../utils/validators";
function ResetPassword() {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [validToken ,setValidToken] = useState(false);
  const [newpassword,setNewPassword]=useState("");
  const [passwordErrror,setPasswordError]=useState("");
  const [confirmPasswordError,setConfirmPasswordError]=useState("");
  const [newConfirmedPassword,setNewConfirmedPassword]=useState("");
  const [passwordStrength, setPasswordStrength] = useState(0);
  const navigate = useNavigate();

  const [token,setToken]=useState("");
  const [globalError,setGlobalError]=useState("");
  useEffect(()=>{
    const params = new URLSearchParams(window.location.search);
    const tokens = params.get("token");
    if (tokens){
      console.log(tokens);
      setToken(tokens);
    }
  },[])
  // Email validation
  const validateEmail = (value) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!value) return "Email is required.";
    if (!emailRegex.test(value)) return "Please enter a valid email.";
    return "";
  };

  // Handle blur for validation
  const handleEmailBlur = (e) => {
    setEmailError(validateEmail(e.target.value));
  };
  const handlePasswordBlur = (e) => {
    const value = e.target.value;
    setPasswordError(validatePassword(value));
  };
  const handleConfirmPasswordBlur = (e) => {
    setConfirmPasswordError(validateConfirmPassword(e.target.value, newpassword));
  };
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setNewPassword(value);
    setPasswordStrength(calculatePasswordStrength(value));
  };
  // Handle form submission
  const handleSubmit = async (e) => {
    console.log(token);
    if (!token){
      e.preventDefault();
      const error = validateEmail(email);
      setEmailError(error);
      if (!error) {
        try{
          forgotPassword({email : email});
          console.log("Password reset requested for:", email);
        }catch(error){
          setGlobalError(error.message)
        }

        // TODO: Send email to Django backend for password reset
      }
    }else{
      try{
        e.preventDefault();
        const results=await resetPassword({token:token,password : newpassword,confirmPassword : newConfirmedPassword});
        if (results?.message!=="password successfully reset"){
          setGlobalError(results.message)
        }else{
          navigate('/login', { replace: true });
        }
        
      }catch (error){
        setGlobalError(error.message)
      }
      
    }

  };
  if (token){
    return(
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
    <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-8">
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Reset Your Password
        </h2>
        <p className="text-gray-600 text-sm">
          Enter your new password
        </p>
      </div>

      <div  className="space-y-4">
      <PasswordField
              label="Password"
              value={newpassword}
              onChange={handlePasswordChange}
              onBlur={handlePasswordBlur}
              error={passwordErrror}
              placeholder="Enter your password"
              required
              showStrength
              strength={passwordStrength}
            />
    <PasswordField
              label="Password"
              value={newConfirmedPassword}
              onChange={(e) => setNewConfirmedPassword(e.target.value)}
              onBlur={handleConfirmPasswordBlur}
              error={confirmPasswordError}
              placeholder="Confirm your password"
              required
          
            />


        <button
          type="button"
          onClick={handleSubmit}
          disabled={!!(confirmPasswordError || passwordErrror)}
          className={`w-full py-2 px-4 rounded-md font-semibold text-sm text-white transition-colors ${
            (newpassword && newConfirmedPassword) && !(confirmPasswordError || passwordErrror)
              ? "bg-blue-600 hover:bg-blue-700"
              : "bg-gray-400 cursor-not-allowed"
          }`}
        >
          Reset Password
        </button>
        {globalError && (
              <p className="text-red-500 text-xs mt-1">{globalError}</p>
            )}
      </div>
    </div>
  </div>
);
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-8">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Reset Your Password
          </h2>
          <p className="text-gray-600 text-sm">
            Enter the email linked to your account. We’ll send you a link to reset
            your password.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Email Address
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onBlur={handleEmailBlur}
              placeholder="Enter your email"
              className={`w-full text-sm text-gray-700 border ${
                emailError ? "border-red-500" : "border-gray-300"
              } rounded-md py-2 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500`}
            />
            {emailError && (
              <p className="text-red-500 text-xs mt-1">{emailError}</p>
            )}
          </div>

          <button
            type="submit"
            disabled={!!emailError}
            className={`w-full py-2 px-4 rounded-md font-semibold text-sm text-white transition-colors ${
              email && !emailError
                ? "bg-blue-600 hover:bg-blue-700"
                : "bg-gray-400 cursor-not-allowed"
            }`}
          >
            Reset Password
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;